"use client";

import { WebHaptics } from "web-haptics";
import type { HapticInput } from "web-haptics";

import type { FeedbackEvent } from "./feedback-events";

/**
 * Haptic layer over `web-haptics`. It uses the Vibration API on Android and the
 * iOS 17.4+ switch-element hack on Safari, so haptics fire on both platforms.
 *
 * The instance is created lazily on first trigger to keep module import SSR-safe
 * (the constructor touches the DOM to set up the iOS switch element).
 */
const HAPTIC_MAP: Record<FeedbackEvent, HapticInput> = {
  tap: "selection",
  select: "selection",
  "toggle-on": "medium",
  "toggle-off": "light",
  open: "soft",
  close: "selection",
  success: "success",
  warn: "warning",
  error: "error",
  copy: "selection",
  delete: "heavy",
  send: "light",
  undo: "selection",
  notify: "soft",
  info: "selection",
};

let instance: WebHaptics | null = null;

function getInstance(): WebHaptics | null {
  if (typeof window === "undefined") {
    return null;
  }

  if (!instance) {
    instance = new WebHaptics();
  }

  return instance;
}

/** Fire the haptic pattern mapped to a feedback event. No-op outside the browser. */
export function triggerHaptic(event: FeedbackEvent): void {
  const haptics = getInstance();

  if (!haptics) {
    return;
  }

  void haptics.trigger(HAPTIC_MAP[event]);
}
